//@ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
import StyledCard from "./StyledInfoCard-APP_CLIENT.styled";

export default StyledCard;
